export const CONCEPT_EXPRESSIONS_LOCALSTORAGE_KEY = 'entityConceptExps';

export const ENTITY_CONCEPT_EXPRESSIONS_GENERATED = 'ENTITY_CONCEPTEXPS_GENERATED';
